import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "antd/lib/pagination";
import {
  setWidgetMakerGraphData,
  setWidgetMakerShareGraphData,
  setWidgetMakerSharePageGraphData,
  setPageChart,
  getDeepDive,
} from "../../redux/actions/WidgetMaker/WidgetAPI";
import { setPostCardOrderBy } from "../../redux/actions/WidgetMaker/GraphConfig";
import { FilterPillsDeepDiveResponse } from "../../redux/actions/dashboard/Tab1";
import {
  getAllDeepDiveDashboardFilters,
  getAllFilters,
  getAllShareFilters,
  getAllTemplateFilters,
  getGlobalBrands,
  getPaneIndex,
  getWidgetGraphObject,
  getWindowLocationPath,
  useQuery,
} from "../../redux/constants";
import { setDeepDiveInfoLoader } from "../../redux/actions/DeepDive";
import {
  setDeepDiveInfluencersObject,
  setDeepDiveMentionsObject,
} from "../../redux/actions/WidgetMaker/WidgetMaker";
import isEqual from "react-fast-compare";
import { supportedBenchmarkTraceDashboardTypes } from "../../redux/constants/enums";
import { setSortByChangeInMetaDataInDeepDiveDashboard } from "../../redux/actions/DeepDiveDashboard/DeepDiveDashboard";

const PaginationComponent = ({
  data,
  filterPills,
  totalPageNo,
  metadata,
  section_index,
  widget_index,
  pagination,
  deepDive,
  isPreviewState,
  PdfDownloadStatus,
  PptGeneratingStatus,
  widget_id,
  chart_type,
  type,
  onPaginationChange,
}) => {
  const dispatch = useDispatch();
  let query = useQuery();
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const mentions_object = useSelector(
    (state) => state.WidgetMaker.deep_dive_mentions_object
  );
  const influencers_object = useSelector(
    (state) => state.WidgetMaker.deep_dive_influencers_object
  );
  const authParams = useSelector((state) => state.Authentication.authParams);

  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const templateDetails = useSelector((state) => state.Section.templateDetails);
  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const Section = useSelector((state) => state.Section.addSection);
  const footerValue = useSelector((state) => state.Section.footerValue);
  const screen = useSelector((state) => state?.Screens?.screen);
  const deepdive_news_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_news_object
  );
  const temporary_words = useSelector(
    (state) => state?.attributes?.temporary_words
  );
  const deepdiveDashboardData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardData
  );
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );

  let currentPage = deepDive
    ? widget_id === "1.1"
      ? mentions_object?.deepdive_on?.order_by?.offset / 12
      : widget_id === "4.1"
      ? influencers_object?.deepdive_on?.order_by?.offset / 12
      : widget_id === "1.2"
      ? deepdive_news_object?.order_by?.offset / 10
      : 0
    : metadata?.order_by?.offset
    ? metadata?.chart?.chart_type === "news-card" ||
      metadata?.graph_type === "news-card"
      ? metadata?.order_by?.offset / 10
      : metadata?.order_by?.offset / 12
    : widgetGraphConfig?.chart_type === "news-card"
    ? widgetGraphConfig?.order_by?.offset / 10
    : widgetGraphConfig?.order_by
    ? widgetGraphConfig?.order_by?.offset / 12
    : 0;

  let totalPageLength =
    chart_type === "news-card" ? totalPageNo * 10 : totalPageNo * 12;

  const handleChangePagination = (page) => {
    let newPage = page - 1;
    let pageNo = chart_type === "news-card" ? newPage * 10 : newPage * 12;
    let index = getPaneIndex(panes, activeKey);
    let finalState;
    let pathName = getWindowLocationPath()?.toLowerCase();
    if (pathName === "edit-dashboard" || pathName === "create-dashboard") {
      if (metadata) {
        let sectionObj = {
          filters: templateDetails?.templateFilters,
          quick_filter_value: templateDetails?.quick_filter_value,
          hidden_filter: templateDetails?.hidden_filter,
          adsset_value: templateDetails?.adsset_value,
          ads_value: templateDetails?.ads_value,
        };
        let filter = getAllTemplateFilters(
          graphConditionConfig,
          Section,
          section_index,
          widget_index,
          sectionObj
        );

        let duration = templateDetails?.templateDuration
          ? templateDetails?.templateDuration
          : null;
        let global_brands =
          templateDetails?.templateBrands?.columns?.length > 0
            ? templateDetails?.templateBrands?.columns
            : templateDetails?.templateBrands?.length > 0
            ? templateDetails?.templateBrands
            : null;

        let updatedOrderBy = {
          attribute: metadata?.order_by?.attribute,
          data_source: metadata?.data_source,
          sort_order: metadata?.order_by?.sort_order,
          offset: pageNo,
        };

        let filter_by_data;
        let postcard_pills_filter;
        if (metadata?.y_axes?.length > 0 && chart_type === "post-card") {
          filter_by_data = {
            attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
            data_source: metadata?.y_axes?.[0]?.data_source,
            data: filterPills,
          };

          let selectedPill;
          filterPills &&
            filterPills?.map((d) => {
              if (d?.highlight) {
                selectedPill = d?.text;
              }
            });

          postcard_pills_filter = {
            attribute: metadata?.y_axes && metadata?.y_axes[0].attribute,
            data_source: metadata?.y_axes[0].data_source,
            type: "varchar",
            columns: [{ name: selectedPill, type: "include" }],
          };
        }

        let indexes = {
          section_index:
            footerValue?.section && section_index >= 0 ? section_index : null,
          templateFilter: true,
          widget_index: widget_index,
          widget_id: metadata?.widget_id,
          section: Section,
          graph_type: metadata?.graph_type ? metadata?.graph_type : chart_type,
          section_id:
            section_index >= 0
              ? Section?.[section_index]?.id
              : Section?.[0]?.id,
          template_details: templateDetails,
        };

        let sectionObjN = {
          brandFilters: Section?.[section_index ? section_index : 0]
            ?.brandFilters
            ? Section?.[section_index ? section_index : 0]?.brandFilters
            : [],
          filters: Section?.[section_index ? section_index : 0]?.filters
            ? Section?.[section_index ? section_index : 0]?.filters
            : [],
          duration: Section?.[section_index ? section_index : 0]?.duration
            ? Section?.[section_index ? section_index : 0]?.duration
            : null,
          dateFilters: Section?.[section_index ? section_index : 0]?.dateFilters
            ? Section?.[section_index ? section_index : 0]?.dateFilters
            : [],
          is_locked: Section?.[section_index ? section_index : 0]?.is_locked
            ? Section?.[section_index ? section_index : 0]?.is_locked
            : false,
          quick_filter_value: templateDetails?.quick_filter_value,
        };
        let widgetObj = {
          filters: metadata?.filters ? metadata?.filters : [],
          duration: {
            from: metadata?.start_date
              ? metadata?.start_date
              : metadata?.dateFilters?.from
              ? metadata?.dateFilters?.from
              : null,
            to: metadata?.end_date
              ? metadata?.end_date
              : metadata?.dateFilters?.to
              ? metadata?.dateFilters?.to
              : null,
          },
          is_locked: metadata?.is_locked ? metadata?.is_locked : false,
        };
        let obj = {};
        obj.section_index = section_index >= 0 ? section_index : null;
        obj.widget_index = widget_index;

        obj.competition_aggregation =
          supportedBenchmarkTraceDashboardTypes?.includes(
            templateDetails?.template_type
          )
            ? templateDetails?.competition_aggregation || "avg"
            : null;
        obj.template_type = templateDetails?.template_type;
        obj.public_engagement_only =
          templateDetails?.public_engagement_only || false;
        obj.duration = duration;
        obj.global_brands = global_brands;
        obj.filter = filter;
        obj.widget = metadata;
        obj.brandlogicalgroup = brandlogicalgroup?.length
          ? brandlogicalgroup
          : null;
        obj.brands = brands?.length ? brands : null;
        obj.authParams = authParams;
        obj.sectionObj = sectionObjN;
        obj.widgetObj = widgetObj;
        obj.type = "template";
        obj.offset_flag = true;

        obj.filter_dropdown = metadata?.filter_dropdown
          ? metadata?.filter_dropdown
          : [];
        obj.filter_by_dropdown = metadata?.filter_by_dropdown
          ? metadata?.filter_by_dropdown
          : [];
        obj.filter_by_dropdown_data = metadata?.filter_by_dropdown_data
          ? metadata?.filter_by_dropdown_data
          : [];

        let widgetGraphObject = getWidgetGraphObject(obj);
        if (widgetGraphObject && chart_type === "post-card") {
          widgetGraphObject.order_by = updatedOrderBy;
          widgetGraphObject.filter_by_data = metadata?.y_axes && filter_by_data;
          widgetGraphObject.filter_by =
            metadata?.y_axes && postcard_pills_filter;
          widgetGraphObject.chart = {
            chart_type: chart_type,
            rich_fields_content: metadata?.chart?.rich_fields_content,
            chart_settings: {
              ...metadata?.chart?.chart_settings,
              duration_comparison: false, // This is used for only KPI
              show_previous_duration_comparison: false, // This is used for charts
              show_previous_duration_data: false, // This is used for charts
              show_as_median: false, // this is used for scatter chart
              show_data_labels: true,
              show_label_names: true,
              is_stacked: true,
              show_count_cards: true,
              card_percent: true,
              chart_percent: false,
              gradient_color: false,
              chart_property: {
                ...metadata?.chart?.chart_settings?.chart_property,
                chart_name: chart_type,
                legend_position: "top",
                y_axis_mode: 2,
              },
              y_axes_settings: [],
              cards_settings: [],
            },
          };
        } else if (
          widgetGraphObject &&
          (chart_type === "review-card" ||
            chart_type === "author-card" ||
            chart_type === "news-card" ||
            chart_type === "survey-card" ||
            chart_type === "prolific-user")
        ) {
          widgetGraphObject.order_by = updatedOrderBy;
        } else if (chart_type === "network-graph-v2") {
          widgetGraphObject.isNetworkChartV2 =
            widgetGraphObject?.chart?.chart_type === "network-graph-v2"
              ? true
              : false;
        }
        if (section_index >= 0 && metadata?.order_by) {
          Section[section_index].data[widget_index].order_by = updatedOrderBy;
          if (
            graphConditionConfig?.[`data-source`]?.includes(
              metadata?.data_source
            )
          ) {
            dispatch(setPageChart(authParams, widgetGraphObject, indexes));
          } else {
            dispatch(
              setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
            );
          }
        } else {
          Section[0].data[widget_index].order_by = updatedOrderBy;
          if (
            graphConditionConfig?.[`data-source`]?.includes(
              metadata?.data_source
            )
          ) {
            dispatch(setPageChart(authParams, widgetGraphObject, indexes));
          } else {
            dispatch(
              setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
            );
          }
        }
      }
    } else if (
      metadata &&
      !deepDive &&
      (((pathName === "dashboard" || pathName === "pin-dashboard") &&
        !panes?.[index]?.is_widget_maker_open_obj?.open_flag &&
        panes?.[index]?.isDeepDiveDashboard) ||
        shareTemplateData?.isDeepDiveDashboard ||
        screen?.isDeepDiveDashboard)
    ) {
      let updatedOrderBy = {
        attribute: metadata?.order_by?.attribute,
        sort_order: metadata?.order_by?.sort_order,
        offset: pageNo,
      };
      let filter_by_data;
      let postcard_pills_filter;
      if (metadata?.y_axes?.length > 0 && chart_type === "post-card") {
        filter_by_data = {
          attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
          data: filterPills,
        };
        let selectedPill;
        filterPills &&
          filterPills?.map((d) => {
            if (d?.highlight) {
              selectedPill = d?.text;
            }
          });
        postcard_pills_filter = {
          attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
          type: "varchar",
          columns: [{ name: selectedPill, type: "include" }],
        };
      }
      if (metadata) {
        dispatch(
          setSortByChangeInMetaDataInDeepDiveDashboard(
            section_index,
            widget_index,
            false, // TO BE CLEAR GRAPGH DATA
            "PAGINATION_CHANGE",
            {
              order_by: updatedOrderBy,
              filter_by_data:
                metadata?.y_axes?.length && filter_by_data
                  ? filter_by_data
                  : null,
              filter_by:
                metadata?.y_axes?.length && postcard_pills_filter
                  ? postcard_pills_filter
                  : null,
            }
          )
        );
        let dashboardData = deepdiveDashboardData;
        let templateData = deepdiveDashboardTemplateData;
        let section =
          templateData?.sections?.length > 0
            ? templateData?.sections?.[section_index]
            : null;
        let duration = dashboardData?.duration
          ? dashboardData?.duration
          : dashboardData?.from
          ? {
              from: dashboardData?.from,
              to: dashboardData?.to,
            }
          : dashboardData?.start_date
          ? {
              from: dashboardData?.start_date,
              to: dashboardData?.end_date,
            }
          : null;

        let global_brands = dashboardData?.brands;
        let brandsContainter = {
          brand_ids: metadata?.brand_ids,
          brand_groups: metadata?.brand_groups,
          singleBrands: brands,
          brandGroupList: brandlogicalgroup,
        };
        let filter = getAllDeepDiveDashboardFilters(
          graphConditionConfig,
          dashboardData,
          deepdiveDashboardTemplateData,
          section_index,
          widget_index,
          brandsContainter
        );
        let indexes = {
          section_index: section_index,
          widget_index: widget_index,
          widget_id: metadata?.widget_id ? metadata?.widget_id : widget_id,
          graph_type: metadata?.graph_type,
          section_id: section?.section_id,
          deepdiveDashboardTemplateData: templateData,
          deepdiveDashboardData: deepdiveDashboardData,
          isDeepdiveDashboard: true,
        };

        let obj = {};
        obj.section_index = section_index;
        obj.widget_index = widget_index;
        obj.data = metadata;
        obj.deepdiveDashboardData = deepdiveDashboardData;
        obj.deepdiveDashboardTemplateData = deepdiveDashboardTemplateData;
        obj.duration = duration;
        obj.global_brands = global_brands;
        obj.filter = filter;
        obj.temporary_words = temporary_words;
        obj.brandlogicalgroup = brandlogicalgroup;
        obj.brands = brands;
        obj.graphConditionConfig = graphConditionConfig;
        obj.authParams = authParams;
        obj.type = "deepdive_dashboard";
        obj.filter_by_data = metadata?.filter_by_data;
        obj.filter_by = metadata?.filter_by;
        obj.offset_flag = true;

        obj.filter_dropdown = metadata?.filter_dropdown
          ? metadata?.filter_dropdown
          : [];
        obj.filter_by_dropdown = metadata?.filter_by_dropdown
          ? metadata?.filter_by_dropdown
          : [];
        obj.filter_by_dropdown_data = metadata?.filter_by_dropdown_data
          ? metadata?.filter_by_dropdown_data
          : [];

        let widgetGraphObject = getWidgetGraphObject(obj);
        if (widgetGraphObject && chart_type === "post-card") {
          widgetGraphObject.order_by = updatedOrderBy;
          widgetGraphObject.filter_by_data =
            metadata?.y_axes?.length && filter_by_data ? filter_by_data : null;
          widgetGraphObject.filter_by =
            metadata?.y_axes?.length && postcard_pills_filter
              ? postcard_pills_filter
              : null;
        } else {
          widgetGraphObject.order_by = updatedOrderBy;
        }
        if (chart_type === "network-graph-v2") {
          widgetGraphObject.isNetworkChartV2 =
            widgetGraphObject?.chart?.chart_type === "network-graph-v2"
              ? true
              : false;
        }
        if (!shareBrands) {
          if (
            graphConditionConfig?.[`data-source`]?.includes(
              widgetGraphObject?.data_source
            )
          ) {
            dispatch(setPageChart(authParams, widgetGraphObject, indexes));
          } else {
            dispatch(
              setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
            );
          }
        } else {
          indexes.shareBrands = shareBrands;
          if (
            graphConditionConfig?.[`data-source`]?.includes(
              widgetGraphObject?.data_source
            )
          ) {
            dispatch(
              setWidgetMakerSharePageGraphData(
                widgetGraphObject,
                shareCategory,
                indexes,
                null,
                query?.get("share_id")
              )
            );
          } else {
            dispatch(
              setWidgetMakerShareGraphData(
                widgetGraphObject,
                shareCategory,
                indexes,
                null,
                query?.get("share_id")
              )
            );
          }
        }
      }
    } else if (deepDive) {
      let widget_ids = [widget_id];
      let influencers_att_name = "InfluencerCategory";
      let filter_by_data = {
        attribute: influencers_att_name,
        data: filterPills,
      };
      let selectedPill;
      if (chart_type === "post-card" || deepDive) {
        filterPills?.map((d) => {
          if (d.highlight) {
            selectedPill = d?.text;
          }
        });
      }
      let postcard_pills_filter = {
        attribute: influencers_att_name,
        type: "varchar",
        columns: [{ name: selectedPill, type: "include" }],
      };

      let mentions_data = {
        ...mentions_object,
        tabName: widget_id === "1.1" ? "Mentions" : "Influencers",
        deepdive_on: {
          ...mentions_object?.deepdive_on,
          order_by: {
            attribute:
              deepDive &&
              widget_id === "1.1" &&
              mentions_object?.deepdive_on?.order_by?.attribute
                ? mentions_object?.deepdive_on?.order_by?.attribute
                : "engagement",
            sort_order:
              deepDive &&
              widget_id === "1.1" &&
              mentions_object?.deepdive_on?.order_by?.sort_order
                ? mentions_object?.deepdive_on?.order_by?.sort_order
                : "desc",
            offset: pageNo,
            widget_ids: widget_ids[0],
          },
        },
        shareTemplateData: shareTemplateData,
        shareBrands: shareBrands,
      };

      let influencers_data = {
        ...influencers_object,
        tabName: widget_id === "1.1" ? "Mentions" : "Influencers",
        filter_by_data:
          chart_type === "post-card" || deepDive ? filter_by_data : null,
        filter_by:
          chart_type === "post-card" || deepDive ? postcard_pills_filter : null,
        deepdive_on: {
          ...influencers_object?.deepdive_on,
          order_by: {
            attribute:
              deepDive &&
              widget_id === "4.1" &&
              influencers_object?.deepdive_on?.order_by?.attribute
                ? influencers_object?.deepdive_on?.order_by?.attribute
                : "engagement",
            sort_order:
              deepDive &&
              widget_id === "4.1" &&
              influencers_object?.deepdive_on?.order_by?.sort_order
                ? influencers_object?.deepdive_on?.order_by?.sort_order
                : "desc",
            offset: pageNo,
            widget_ids: widget_ids[0],
          },
        },
        shareTemplateData: shareTemplateData,
        shareBrands: shareBrands,
      };

      widget_id === "1.1" &&
        dispatch(setDeepDiveMentionsObject(mentions_data, panes, index));
      widget_id === "4.1" &&
        dispatch(setDeepDiveInfluencersObject(influencers_data, panes, index));
      dispatch(setDeepDiveInfoLoader(true));
      let finalObject = widget_id === "1.1" ? mentions_data : influencers_data;

      if (pathName === "CommandCenter"?.toLowerCase()) {
        if (widget_id === "4.1") {
          let deep_dive_obj = { influencers: [] };
          dispatch({
            type: "SET_DEEP_DIVE_DATA_IN_SCREEN",
            isDeepDive: true,
            deep_dive: deep_dive_obj,
          });
        }

        finalObject.screen = screen;
        // console.log("widget_ids", widget_ids);
        dispatch(getDeepDive(authParams, finalObject, widget_ids));
      } else {
        dispatch(
          FilterPillsDeepDiveResponse(
            panes,
            index,
            authParams,
            finalObject,
            widget_ids,
            query?.get("share_id")
          )
        );
      }
    } else if (shareTemplateData) {
      if (metadata) {
        if (section_index >= 0) {
          finalState =
            shareTemplateData?.sections[section_index]?.widgets[widget_index];
        } else {
          finalState =
            shareTemplateData?.section &&
            shareTemplateData?.section[0]?.widgets[widget_index];
        }
      }
      // to delete widget from list
      if (section_index >= 0) {
        let sectionLevel = {
          ...shareTemplateData,
          sections: shareTemplateData?.sections?.map((el, i) => {
            if (i === section_index) {
              return {
                ...el,
                widgets: el.widgets?.map((d, i) => {
                  if (i === widget_index) {
                    d.graphData = null;
                    d.persist_graphdata = null;
                    d.deep_dive_on = null;
                    return { ...d };
                  } else {
                    return { ...d };
                  }
                }),
              };
            } else {
              return { ...el };
            }
          }),
        };
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: sectionLevel,
        });
      } else {
        let sectionLevel = {
          ...shareTemplateData,
          section: shareTemplateData?.section?.map((el, i) => {
            return {
              ...el,
              widgets: el.widgets?.map((d, i) => {
                if (i === widget_index) {
                  d.graphData = null;
                  d.persist_graphdata = null;
                  d.deep_dive_on = null;
                  return { ...d };
                } else {
                  return { ...d };
                }
              }),
            };
          }),
        };
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: sectionLevel,
        });
      }

      if (metadata) {
        let filter = getAllShareFilters(
          graphConditionConfig,
          shareTemplateData,
          section_index,
          widget_index,
          shareBrands
        );

        let updatedOrderBy = {
          attribute: finalState?.order_by?.attribute,
          sort_order: finalState?.order_by?.sort_order,
          offset: pageNo,
        };
        let filter_by_data;
        let postcard_pills_filter;
        if (metadata?.y_axes?.length > 0 && chart_type === "post-card") {
          filter_by_data = {
            attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
            data: filterPills,
          };
          let selectedPill;
          filterPills &&
            filterPills?.map((d) => {
              if (d?.highlight) {
                selectedPill = d?.text;
              }
            });
          postcard_pills_filter = {
            attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
            type: "varchar",
            columns: [{ name: selectedPill, type: "include" }],
          };
        }

        let duration = shareTemplateData?.duration?.from
          ? {
              from: shareTemplateData?.duration?.from
                ? shareTemplateData?.duration?.from
                : null,
              to: shareTemplateData?.duration?.to
                ? shareTemplateData?.duration?.to
                : null,
            }
          : shareTemplateData?.start_date
          ? {
              from: shareTemplateData?.start_date
                ? shareTemplateData?.start_date
                : null,
              to: shareTemplateData?.end_date
                ? shareTemplateData?.end_date
                : null,
            }
          : null;

        let obj = {};
        obj.type = "share_dashboard";
        obj.section_index = section_index;
        obj.widget_index = widget_index;
        obj.data = metadata;
        obj.shareTemplateData = shareTemplateData;
        obj.duration = duration;
        obj.filter = filter;
        obj.shareBrands = shareBrands;
        obj.offset_flag = true;

        obj.filter_dropdown = metadata?.filter_dropdown
          ? metadata?.filter_dropdown
          : [];
        obj.filter_by_dropdown = metadata?.filter_by_dropdown
          ? metadata?.filter_by_dropdown
          : [];
        obj.filter_by_dropdown_data = metadata?.filter_by_dropdown_data
          ? metadata?.filter_by_dropdown_data
          : [];

        let widgetGraphObject = getWidgetGraphObject(obj);
        if (widgetGraphObject && chart_type === "post-card") {
          widgetGraphObject.order_by = updatedOrderBy;
          widgetGraphObject.filter_by_data = metadata?.y_axes && filter_by_data;
          widgetGraphObject.filter_by =
            metadata?.y_axes && postcard_pills_filter;
          widgetGraphObject.chart = {
            chart_type: chart_type,
            rich_fields_content: metadata?.chart?.rich_fields_content,
            chart_settings: {
              ...metadata?.chart?.chart_settings,
              duration_comparison: false, // This is used for only KPI
              show_previous_duration_comparison: false, // This is used for charts
              show_previous_duration_data: false, // This is used for charts
              show_as_median: false, // this is used for scatter chart
              show_data_labels: true,
              show_label_names: true,
              is_stacked: true,
              show_count_cards: true,
              card_percent: true,
              chart_percent: false,
              gradient_color: false,
              chart_property: {
                ...metadata?.chart?.chart_settings?.chart_property,
                chart_name: chart_type,
                legend_position: "top",
                y_axis_mode: 2,
              },
              y_axes_settings: [],
              cards_settings: [],
            },
          };
        } else if (
          widgetGraphObject &&
          (chart_type === "review-card" ||
            chart_type === "author-card" ||
            chart_type === "prolific-user" ||
            chart_type === "survey-card" ||
            chart_type === "news-card")
        ) {
          widgetGraphObject.order_by = updatedOrderBy;
        }

        let indexes = {
          section_index: section_index,
          templateFilter: true,
          widget_index: widget_index,
          widget_id: metadata?.widget_id,
          section:
            section_index >= 0
              ? shareTemplateData?.sections
              : shareTemplateData?.section,
          graph_type: metadata?.graph_type ? metadata?.graph_type : chart_type,
          section_id:
            section_index >= 0
              ? shareTemplateData?.sections?.[section_index]?.section_id
              : shareTemplateData?.section?.[0]?.section_id,
          shareTemplateData: shareTemplateData,
        };
        let share = {
          sections: shareTemplateData,
        };

        if (section_index >= 0) {
          shareTemplateData.sections[section_index].widgets[
            widget_index
          ].order_by = updatedOrderBy;
          graphConditionConfig?.[`data-source`]?.includes(
            widgetGraphObject?.data_source
          )
            ? dispatch(
                setWidgetMakerSharePageGraphData(
                  widgetGraphObject,
                  shareCategory,
                  indexes,
                  share,
                  query?.get("share_id")
                )
              )
            : dispatch(
                setWidgetMakerShareGraphData(
                  widgetGraphObject,
                  shareCategory,
                  indexes,
                  share,
                  query?.get("share_id")
                )
              );
        } else {
          shareTemplateData.section[0].widgets[widget_index].order_by =
            updatedOrderBy;
          graphConditionConfig?.[`data-source`]?.includes(
            widgetGraphObject?.data_source
          )
            ? dispatch(
                setWidgetMakerSharePageGraphData(
                  widgetGraphObject,
                  shareCategory,
                  indexes,
                  share,
                  query?.get("share_id")
                )
              )
            : dispatch(
                setWidgetMakerShareGraphData(
                  widgetGraphObject,
                  shareCategory,
                  indexes,
                  share,
                  query?.get("share_id")
                )
              );
        }
      }
    } else if (type === "authorDetailsWithPost") {
      if (metadata) {
        let updatedOrderBy = {
          attribute: metadata?.order_by?.attribute,
          sort_order: metadata?.order_by?.sort_order,
          offset: pageNo,
        };
        let filter_by_data;
        let postcard_pills_filter;
        if (metadata?.y_axes?.length > 0 && chart_type === "post-card") {
          filter_by_data = {
            attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
            data: filterPills,
          };
          let selectedPill;
          filterPills &&
            filterPills?.map((d) => {
              if (d?.highlight) {
                selectedPill = d?.text;
              }
            });
          postcard_pills_filter = {
            attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
            type: "varchar",
            columns: [{ name: selectedPill, type: "include" }],
          };
        }
        let updatedMetaData = structuredClone(metadata);
        updatedMetaData.order_by = updatedOrderBy;
        updatedMetaData.filter_by_data = filter_by_data;
        updatedMetaData.filter_by = postcard_pills_filter;
        if (onPaginationChange && typeof onPaginationChange === "function") {
          onPaginationChange(updatedMetaData);
        }
      }
    } else {
      let widgetObj = {
        brand_groups: metadata?.brand_groups,
        singleBrands: brands,
      };
      let filter = getAllFilters(
        graphConditionConfig,
        panes,
        index,
        section_index,
        widget_index,
        brandlogicalgroup,
        metadata?.brand_ids, //logical brand change
        widgetObj
      );

      if (metadata) {
        let duration = panes[index]?.duration;
        // let global_brands = getGlobalBrands(
        //   panes[index]?.brands,
        //   global_dashboard_single_brands,
        //   global_dashboard_brands,
        //   panes[index]?.template_type
        // );
        let global_brands = panes?.[index]?.brands;
        let indexes = {
          pane_index: index,
          section_index: section_index >= 0 ? section_index : null,
          panes: panes,
          widget_index: widget_index,
          widget_id: metadata?.widget_id,
          graph_type: metadata?.graph_type,
          section_id:
            section_index >= 0
              ? panes?.[index]?.sections?.[section_index]?.section_id
              : panes?.[index]?.section?.[0]?.section_id,
        };
        let updatedOrderBy = {
          attribute: metadata?.order_by?.attribute,
          sort_order: metadata?.order_by?.sort_order,
          offset: pageNo,
        };
        let filter_by_data;
        let postcard_pills_filter;
        if (metadata?.y_axes?.length > 0 && chart_type === "post-card") {
          filter_by_data = {
            attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
            data: filterPills,
          };
          let selectedPill;
          filterPills &&
            filterPills?.map((d) => {
              if (d?.highlight) {
                selectedPill = d?.text;
              }
            });
          postcard_pills_filter = {
            attribute: metadata?.y_axes && metadata?.y_axes?.[0]?.attribute,
            type: "varchar",
            columns: [{ name: selectedPill, type: "include" }],
          };
        }

        let obj = {};
        obj.section_index = section_index;
        obj.widget_index = widget_index;
        obj.data = metadata;
        obj.panes = panes;
        obj.paneIndex = index;
        obj.duration = duration;
        obj.global_brands = global_brands;
        obj.filter = filter;
        obj.brandlogicalgroup = brandlogicalgroup;
        obj.brands = brands;
        obj.authParams = authParams;
        obj.type = "view";
        obj.offset_flag = true;

        obj.filter_dropdown = metadata?.filter_dropdown
          ? metadata?.filter_dropdown
          : [];
        obj.filter_by_dropdown = metadata?.filter_by_dropdown
          ? metadata?.filter_by_dropdown
          : [];
        obj.filter_by_dropdown_data = metadata?.filter_by_dropdown_data
          ? metadata?.filter_by_dropdown_data
          : [];
        let widgetGraphObject = getWidgetGraphObject(obj);
        if (widgetGraphObject && chart_type === "post-card") {
          widgetGraphObject.order_by = updatedOrderBy;
          widgetGraphObject.filter_by_data = metadata?.y_axes && filter_by_data;
          widgetGraphObject.filter_by =
            metadata?.y_axes && postcard_pills_filter;
          widgetGraphObject.chart = {
            chart_type: chart_type,
            rich_fields_content: metadata?.chart?.rich_fields_content,
            chart_settings: {
              ...metadata?.chart?.chart_settings,
              duration_comparison: false, // This is used for only KPI
              show_previous_duration_comparison: false, // This is used for charts
              show_previous_duration_data: false, // This is used for charts
              show_as_median: false, // this is used for scatter chart
              show_data_labels: true,
              show_label_names: true,
              is_stacked: true,
              show_count_cards: true,
              card_percent: true,
              chart_percent: false,
              gradient_color: false,
              chart_property: {
                ...metadata?.chart?.chart_settings?.chart_property,
                chart_name: chart_type,
                legend_position: "top",
                y_axis_mode: 2,
              },
              y_axes_settings: [],
              cards_settings: [],
            },
          };
        } else if (
          widgetGraphObject &&
          (chart_type === "review-card" ||
            chart_type === "author-card" ||
            chart_type === "prolific-user" ||
            chart_type === "survey-card" ||
            chart_type === "news-card")
        ) {
          widgetGraphObject.order_by = updatedOrderBy;
        } else if (chart_type === "network-graph-v2") {
          widgetGraphObject.isNetworkChartV2 =
            widgetGraphObject?.chart?.chart_type === "network-graph-v2"
              ? true
              : false;
        }
        if (section_index >= 0 && metadata?.order_by) {
          panes[index].sections[section_index].widgets[widget_index].order_by =
            updatedOrderBy;
          if (
            graphConditionConfig?.[`data-source`]?.includes(
              metadata?.data_source
            )
          ) {
            dispatch(setPageChart(authParams, widgetGraphObject, indexes));
          } else {
            dispatch(
              setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
            );
          }
        } else {
          if (metadata?.order_by) {
            panes[index].section[0].widgets[widget_index].order_by =
              updatedOrderBy;
            if (
              graphConditionConfig?.[`data-source`]?.includes(
                metadata?.data_source
              )
            ) {
              dispatch(setPageChart(authParams, widgetGraphObject, indexes));
            } else {
              dispatch(
                setWidgetMakerGraphData(authParams, widgetGraphObject, indexes)
              );
            }
          }
        }
      } else {
        dispatch(
          setPostCardOrderBy(pageNo, metadata ? metadata : widgetGraphConfig)
        );
      }
    }
    //  hendleClick();
    document
      ?.getElementById(
        `post_card_${section_index ? section_index : "section_index"}_${
          widget_index ? widget_index : "widget_index"
        }`
      )
      ?.scrollIntoView();
  };
  return (
    <div>
      {!isPreviewState &&
        pagination &&
        data?.length > 0 &&
        !PdfDownloadStatus &&
        !PptGeneratingStatus &&
        (chart_type === "news-card"
          ? totalPageLength > 10
          : totalPageLength > 12) && (
          <div
            style={{
              pointerEvents: isPreviewState ? "none" : "",
            }}
            className={`text-right widgetLibraryPagination pb-15 pr-15 ${
              type === "authorDetailsWithPost" ? "pt-15" : ""
            }`}
          >
            <Pagination
              hideOnSinglePage={totalPageLength > 10 ? false : true}
              pageSize={chart_type === "news-card" ? 10 : 12}
              responsive={true}
              onChange={(e) => handleChangePagination(e)}
              current={currentPage ? currentPage + 1 : 1}
              total={totalPageLength}
              showSizeChanger={false}
              showTitle={false}
            />
          </div>
        )}
    </div>
  );
};

export default React.memo(PaginationComponent, isEqual);
